import styled from 'styled-components';

import { styles } from 'hb-react/shared/components/DesignSystem/QuillEditor/ContentEditable';

import { headingStyles } from '../utils/style';

export const StyledHtml = styled.div<{ isHeadline?: boolean }>`
  width: 100%;
  ${({ isHeadline }) =>
    styles({
      isHeadline,
      defaultLinkColor: false,
      disableLinks: false,
      underlineLinks: true,
    })}
  ${headingStyles}
`;
